import { invoke } from '@tencent/vb-app-bridge';

export async function verify(steps: string, secSession: string, dealJson: Record<string, string>, dealTpl: string) {
  const verifyRes = await invoke(
    {
      path: '/e/coms/webToweex.html',
      query: {
        type: 'security',
        parame: encodeURIComponent(
          JSON.stringify({
            secSession,
            steps,
            dealJson,
            dealTpl,
          }),
        ),
      },
    },
    {
      containerType: 'dialog',
      target: 'weex',
    },
  );
  return verifyRes as {
    code: number;
    data: {
      password: string;
    };
  };
}
